import { HeightUnit } from "@/Common/Utilities/Units/Units";
import { OntarioObstetricalAdditionalInvestigation } from "./OPR2/OntarioObstetricalAdditionalInvestigation";
import { OntarioObstetricalExamAsIndicated } from "./OPR2/OntarioObstetricalExamAsIndicated";
import { OntarioObstetricalInitialLabInvestigation } from "./OPR2/OntarioObstetricalInitialLabInvestigation";
import { OntarioObstetricalNoScreeningTest } from "./OPR2/OntarioObstetricalNoScreeningTest";
import { OntarioObstetricalPrenatalGeneticInvestigations } from "./OPR2/OntarioObstetricalPrenatalGeneticInvestigations";
import { OntarioObstetricalSecondAndThirdTrimesterLab } from "./OPR2/OntarioObstetricalSecondAndThirdTrimesterLab";
import { OntarioObstetricalUltrasound } from "./OPR2/OntarioObstetricalUltrasound";

class OntarioObstetricalFileFormOpr2 {
    public VitalSignEmrTemplateId: string;
    public InitialLabInvestigations: OntarioObstetricalInitialLabInvestigation;
    public SecondAndThirdTrimesterLab: OntarioObstetricalSecondAndThirdTrimesterLab;
    public AdditionalInvestigations: OntarioObstetricalAdditionalInvestigation[];
    public PrenatalGeneticInvestigations: OntarioObstetricalPrenatalGeneticInvestigations;
    public ExamAsIndicated: OntarioObstetricalExamAsIndicated;
    public ExamComments: string;
    public LastPapDate?: Date;
    public LastPapResult: string;
    public NoScreeningTest: OntarioObstetricalNoScreeningTest;
    public Ultrasound: OntarioObstetricalUltrasound[];
    public IsGeneticScreeningResultReviewed?: boolean;
    public IsPage1AndPage2CopiedToHospital?: boolean;
    public IsPage1AndPage2CopiedToClient?: boolean;
    public HeightUnit: HeightUnit;

    private additionalInvestigationsMaximumRows = 8;

    constructor(fields?: Partial<OntarioObstetricalFileFormOpr2>) {
        this.HeightUnit = sessionStore.useMetricSystemAsDefault ? HeightUnit.Centimeter : HeightUnit.Inch;
        Object.assign(this, fields);

        this.InitialLabInvestigations = new OntarioObstetricalInitialLabInvestigation(fields?.InitialLabInvestigations);
        this.SecondAndThirdTrimesterLab = new OntarioObstetricalSecondAndThirdTrimesterLab(fields?.SecondAndThirdTrimesterLab);
        this.AdditionalInvestigations = fields?.AdditionalInvestigations?.map(p => new OntarioObstetricalAdditionalInvestigation(p)) ?? [];

        const emptyRowsCount = this.additionalInvestigationsMaximumRows - this.AdditionalInvestigations.length;

        for (let i = 0; i < emptyRowsCount; i++) {
            this.AdditionalInvestigations.push(new OntarioObstetricalAdditionalInvestigation());
        }

        this.PrenatalGeneticInvestigations = new OntarioObstetricalPrenatalGeneticInvestigations(fields?.PrenatalGeneticInvestigations);
        this.ExamAsIndicated = new OntarioObstetricalExamAsIndicated(fields?.ExamAsIndicated);
        this.NoScreeningTest = new OntarioObstetricalNoScreeningTest(fields?.NoScreeningTest);
        this.Ultrasound = fields?.Ultrasound?.map(p => new OntarioObstetricalUltrasound(p)) ?? [];
    }
}

export { OntarioObstetricalFileFormOpr2 };
